        
    $(document).ready(function(){
      //DOMES
     $(document).on('click','.atc',function () {
       window.scrollTo(0,0);
       
                       var qty = document.getElementById("damount").value;
              
     
              
              $(".dome_qty").val(qty);
       $(this).addClass("added");
         $("h1").hide();
       $(".dome-delivery").hide();
       $(".breadcrumb").hide();
         $("#b2bsurge-dome-app").prepend("<p class=\"text-center wait-text\">Adding dome to the cart please wait</p>\n<p class=\"text-center\"><img width=\"200px\"src=\"https://cdn.shopify.com/s/files/1/0600/8557/files/tenor.gif?v=1509471017\"></p>");
  $("#daylight-app").hide();
      
     var image =  $(".swiper-slide-active img").attr("src");
       
       var price = $(this).attr("data-price");
       
       var desc = $(".product-desc").html().trim();
       
       var size = $("#q_1 select").find(':selected').text();
       
       var ref = $(".product-code").html().trim();
       
       var title = $(".model-desc").html()+" ("+$(".nav-link.active").html()+")".trim() + " - " +size+" - "+ref;
       
 
      //        
     
       
    
           $.get("https://apexfibreglassroofingsupplies.co.uk/apps/store-pickup/?title="+title+"&h="+desc+"&p="+price+"&i="+image, function(data, status){
      
              
              
              $(".dome_product_id").val(data);
               

				$("#product-add-to-cart").click();

        //addtocart(data);        
   });
        
      });
      

       
		//updateInfo();
      

  
    });
      
      //Document Ready
      
      $(window).load(function() {
      //updateInfo();
       update();
        

});
      
       $(document).on('click','body#custom-domes a.nav-link',function () {
       
		//updateInfo();
       
       
     
     });  
      
      
      
      
      $(document).on('change','input, textarea, select',function () {
       
		//updateInfo();
       
       
     
     });  
      
      
  
      function update() {
              var updating = setInterval(function() {
                
                
                if($("button.added").length > 0) {
                  
                  clearInterval(updating);
                  
                } else {
   
     $("h1").html($(".model-desc").html());
          
      $(".dome-delivery").remove();   
      $( "<p class=\"dome-delivery\"><b>FREE Delivery</b> on all domes!</p>" ).insertAfter( "h1" );
         
                  if($(".dome_product_qty").length > 0) {
                    
                  } else {
                  
        $( "<input type=\"number\" id=\"damount\" class=\"dome_product_qty\" name=\"quantity\" min=\"1\" max=\"25\" value=\"1\">" ).insertBefore( ".product-code" );           
                  
                  }   
                  
      totalPrice();
    

                }
                
                }, 400);
        
      }
        

      

      function updateInfo() {
              var checkExist = setInterval(function() {
   		if ($('.total-price span').length) {
     $("h1").html($(".model-desc").html());
          
          $(".dome-delivery").remove();
          
      $( "<p class=\"dome-delivery\"><b>FREE Delivery</b> on all domes!</p>" ).insertAfter( "h1" );
      totalPrice();
      clearInterval(checkExist);
   }
}, 1100); 
        
      }
      
      function totalPrice() {
        
  var str = new String($(".total-price span[title='Manufacturers recommended retail price']").html());
        
        
        if(str.includes("£")) {  
          
            
          
     var str = str.replace(/(l\.)/ig,"");     
     var price_str = str.replace(/([^\d\.]+)/ig,"");
                                 
    
       
      
    var price = new Number(price_str);
          
        
    
  
  var total = price + (price * 0.20);
          
    //total.toFixed(2)      
  var totalPrice = thousands_separators(total);

var totalStr = new String(total);


  var res = totalStr.match(/\.\d$/g);
 



if(res) {


var totalPrice = totalPrice + "0";

} else {





}         
          
                 if($(".popular_configurations").is(":visible")){
                   
                   $(".atc").remove();
                    $(".dome_product_qty").show();
                   
                } else{
                  	$(".atc").remove();
                  
             
                  
                  
                  $(".dome_product_qty").show();
                    $( "<button class=\"atc\" data-price=\"" + total + "\">Add To Cart</button>" ).insertAfter( ".new-price" ); 
                 
                
                }
       
         

          

    $("p.new-price").remove();

        
  $( "<p class=\"new-price\"><b>£" + totalPrice + "</b><br>Price Includes VAT</p>" ).insertAfter( ".total-price span" );
 
        } else {
          
          //$(".addtocartform").hide();
          
              $("p.new-price").remove();

        $(".atc").remove();
           $(".dome_product_qty").hide();
          
    
  $( "<p class=\"new-price\"><b>Adjust your options to get a price!</b></p>" ).insertAfter( ".total-price span" );
          
        }

        
        }
      
      




function thousands_separators(num)
  {
    var num_parts = num.toString().split(".");
    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return num_parts.join(".");
  }     
      
      
      
    
      
      
